import React, { useEffect, useState } from 'react';
import { Alert, Button, Form, Modal, Spinner } from 'react-bootstrap';
import { cashVoucherAPI } from '../../services';

const formatCurrency = (value) =>
  new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
    maximumFractionDigits: 0,
  }).format(Number(value || 0));

/**
 * #164550 — hộp xác nhận HUỶ PHIẾU CHI ĐÃ DUYỆT (khuôn RejectVoucherModal, lệnh sếp 731601112).
 * Nói TRƯỚC hệ quả (AC8/AC13/AC14): hoàn tiền két hay không, phiếu nhập kho/phiếu kiểm hàng bị gỡ
 * hay giữ. Ô lý do cỡ chữ >=16px để Safari trên iPhone không tự phóng to (luật #232509).
 */
const CancelVoucherModal = ({ show, voucher, onConfirm, onHide, loading }) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');
  const [preview, setPreview] = useState(null);
  const [previewLoading, setPreviewLoading] = useState(false);

  useEffect(() => {
    if (!show) return;
    setReason('');
    setError('');
    setPreview(null);
    if (!voucher?.id) return;
    setPreviewLoading(true);
    cashVoucherAPI
      .getVoucherCancelPreview(voucher.id)
      .then((res) => setPreview(res))
      .catch(() => setPreview(null))
      .finally(() => setPreviewLoading(false));
  }, [show, voucher?.id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = reason.trim();
    if (!trimmed) {
      setError('Vui lòng nhập lý do huỷ');
      return;
    }
    setError('');
    onConfirm(trimmed);
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Huỷ phiếu chi</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {voucher && (
            <>
              <p className="text-muted small mb-2">
                Phiếu <strong>{voucher.voucherNumber || voucher.id}</strong> —{' '}
                {formatCurrency(voucher.amount)} · {voucher.branchName}
              </p>
              {voucher.description && (
                <p className="small mb-3">{voucher.description}</p>
              )}
            </>
          )}

          {previewLoading ? (
            <div className="text-center py-3 small text-muted">
              <Spinner size="sm" animation="border" /> Đang kiểm tra ảnh hưởng...
            </div>
          ) : preview?.impact_lines?.length ? (
            <Alert variant="warning" className="small mb-3">
              <div className="fw-semibold mb-1">Ảnh hưởng khi huỷ</div>
              <ul className="mb-0 ps-3">
                {preview.impact_lines.map((line, idx) => (
                  <li key={idx}>{line}</li>
                ))}
              </ul>
            </Alert>
          ) : null}

          <Form.Group>
            <Form.Label>Lý do huỷ *</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Nhập lý do huỷ cụ thể..."
              value={reason}
              onChange={(e) => {
                setReason(e.target.value);
                setError('');
              }}
              isInvalid={!!error}
              autoFocus
              style={{ fontSize: 16 }}
            />
            <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
          </Form.Group>
          <div className="small text-muted mt-2">
            Phiếu sẽ giữ nguyên số phiếu và mang nhãn "Đã huỷ"; không xoá phiếu.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={loading}>
            Đóng
          </Button>
          <Button type="submit" variant="danger" disabled={loading}>
            {loading ? 'Đang xử lý...' : 'Huỷ phiếu'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CancelVoucherModal;
